import store from '../store'

import AppLayout from '../views/layouts/AppLayout'

export default [
  {
    path: '/settings/faculties',
    name: 'settings.faculties.index',
    component: () => import(/* webpackChunkName: "settings_faculties_index" */ '../views/settings/faculties/Index.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('faculty/fetchFacultyList')
      next()
    },
    meta: {
      layout: AppLayout,
      pageTitle: 'คณะ (สังกัด)',
      bodyClass: 'app-page',
      title: 'คณะ (สังกัด)'
    }
  },
  {
    path: '/settings/faculties/:id',
    name: 'settings.faculties.show',
    component: () => import(/* webpackChunkName: "settings_faculties_show" */ '../views/settings/faculties/Show.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('faculty/fetchFaculty', to.params.id)
      next()
    },
    meta: {
      layout: AppLayout,
      pageTitle: 'คณะ (สังกัด)',
      bodyClass: 'app-page',
      title: 'คณะ (สังกัด)'
    }
  }
]
